const memoize = require('memoizee');
const merge = require('lodash/fp/merge');

function memoizerPos(config) {
  return fn => memoize(fn, merge({
    // Remove from cache on promise rejection
    promise: true,
    // Compare objects by string representation
    normalizer: function(args){
        return JSON.stringify(args)
    } ,
    // Auto clear cache
    maxAge: 60000,
    // Prefetch behind the scenes when within (preFetch * maxAge) of maxAge
    preFetch: 0.1,
  }, config));
}

module.exports = memoizerPos;
